var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("Button", {
        attrs: {
          icon: "checkmark",
          text: _vm.inContacting ? "In Kontaktierung" : "Anonym kontaktieren",
          primary: !_vm.inContacting,
          success: _vm.inContacting,
          disabled: _vm.inContacting
        },
        on: { click: _vm.onClick }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }